import './App.css';
import './fonts.css'; // We will add font styles here.
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/Home/home';
import BlogPost from './pages/blog/whyMeta';
import MetaThankYou from './pages/blog/appreciation2025ExecTeam';
import Team from './pages/Team';

function App() {

  return (
    <Router>
      <Routes>
        <Route
  path="/"
  element={
      <HomePage />
  }
/>
        <Route path="/blog/why-join-meta" element={<BlogPost />} />
        <Route path="/executive-team" element={<Team />} />
        <Route path="/blog/farewell-2024-exec-team" element={<MetaThankYou />} />
      </Routes>
    </Router>
  );
}

export default App;
